<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-select class="search-select" v-model="value">
      <el-option :value="''" label="全部"></el-option>
      <el-option v-for="(item,index) in searchTermList" :value="item.id" :label="item.name" :key="index"></el-option>
    </el-select>
  </div>
</template>
<script>
  export default {
    name: "searchSelect",
    props: {
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
      searchTermList:{
        type: Array,
        default: []
      }
    },
    data: function() {
      return {
        value:this.searchValue,
      }
    },
    /* computed: {
    }, */
    methods: {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchSelect.vue